/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A request to change change the state of the Report.  These are signals to the system to change the `ReportStatus`. It is not always  possible to perform each transition.  State changes are subject to the `ReportStatus` state machine.
 */
export type ReportAction = 'CALCULATE' | 'COMPLETE' | 'LODGE' | 'FINALISE' | 'CANCEL' | 'REMOVE';

export const ReportAction = {
    Calculate: 'CALCULATE' as ReportAction,
    Complete: 'COMPLETE' as ReportAction,
    Lodge: 'LODGE' as ReportAction,
    Finalise: 'FINALISE' as ReportAction,
    Cancel: 'CANCEL' as ReportAction,
    Remove: 'REMOVE' as ReportAction
};

